"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeLayer = _interopRequireDefault(require("../../../models/creative/CreativeLayer"));

var _GroupCreativeLayer = _interopRequireDefault(require("../../../models/creative/GroupCreativeLayer"));

var _ImageCreativeLayer = _interopRequireDefault(require("../../../models/creative/ImageCreativeLayer"));

var _ShapeCreativeLayer = _interopRequireDefault(require("../../../models/creative/ShapeCreativeLayer"));

var _SVGCreativeLayer = _interopRequireDefault(require("../../../models/creative/SVGCreativeLayer"));

var _TextCreativeLayer = _interopRequireDefault(require("../../../models/creative/TextCreativeLayer"));

var _VideoCreativeLayer = _interopRequireDefault(require("../../../models/creative/VideoCreativeLayer"));

var _ContentStore = _interopRequireDefault(require("../../store/ContentStore"));

var _CanvasFactory = _interopRequireDefault(require("../../CanvasFactory"));

var _GroupRenderer = _interopRequireDefault(require("../GroupRenderer"));

var _ImageRenderer = _interopRequireDefault(require("../ImageRenderer"));

var _ShapeRenderer = _interopRequireDefault(require("../ShapeRenderer"));

var _SVGRenderer = _interopRequireDefault(require("../SVGRenderer"));

var _TextRenderer = _interopRequireDefault(require("../TextRenderer"));

var _VideoRenderer = _interopRequireDefault(require("../VideoRenderer"));

var _FilterProcessor = _interopRequireDefault(require("../filter/FilterProcessor"));

var _LayerTransformer = _interopRequireDefault(require("../transform/LayerTransformer"));

var _isNil = _interopRequireDefault(require("../../../utils/object/isNil"));

var _text = require("../../../constants/text");

var _CanvasTextRenderer = _interopRequireDefault(require("../CanvasTextRenderer"));

var LayerRendererCache = /*#__PURE__*/function () {
  function LayerRendererCache() {
    (0, _classCallCheck2["default"])(this, LayerRendererCache);
    (0, _defineProperty2["default"])(this, "layerMap", new Map());
  }

  (0, _createClass2["default"])(LayerRendererCache, [{
    key: "getRenderer",
    value: function getRenderer(creativeLayer, contentStore, layerTransformer, filterProcessor, canvasFactory, canvasOptions) {
      if (!_ContentStore["default"].isContentStore(contentStore)) {
        throw new Error('contentStore must be of type ContentStore');
      }

      if (!_CanvasFactory["default"].isCanvasFactory(canvasFactory)) {
        throw new Error('canvasFactory must be of type CanvasFactory');
      }

      if (!_LayerTransformer["default"].isLayerTransformer(layerTransformer)) {
        throw new Error('layerTransformer must be of type LayerTransformer');
      }

      if (!_FilterProcessor["default"].isFilterProcessor(filterProcessor)) {
        throw new Error('layerTransformer must be of type LayerTransformer');
      }

      if (!_CreativeLayer["default"].isCreativeLayer(creativeLayer)) return null; // Create a key with element, content, media id, and other things specific to a layer type

      var layerId = creativeLayer.id; // If we haven't created a layer for this key, make one

      if (!this.layerMap.has(layerId)) {
        // Get bitmap data based on content type
        var layerRenderer;

        if (_ImageCreativeLayer["default"].isImageCreativeLayer(creativeLayer)) {
          layerRenderer = new _ImageRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor);
        } else if (_SVGCreativeLayer["default"].isSVGCreativeLayer(creativeLayer)) {
          layerRenderer = new _SVGRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor);
        } else if (_VideoCreativeLayer["default"].isVideoCreativeLayer(creativeLayer)) {
          layerRenderer = new _VideoRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor);
        } else if (_ShapeCreativeLayer["default"].isShapeCreativeLayer(creativeLayer)) {
          layerRenderer = new _ShapeRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor);
        } else if (_TextCreativeLayer["default"].isTextCreativeLayer(creativeLayer)) {
          if (creativeLayer.textType === _text.TEXT_TYPE.CANVAS) {
            layerRenderer = new _CanvasTextRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor, canvasFactory);
          } else {
            layerRenderer = new _TextRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor);
          }
        } else if (_GroupCreativeLayer["default"].isGroupCreativeLayer(creativeLayer)) {
          layerRenderer = new _GroupRenderer["default"](creativeLayer, contentStore, layerTransformer, filterProcessor, this, canvasFactory, canvasOptions);
        } // If no bitmap data, we don't know how to render this type


        if ((0, _isNil["default"])(layerRenderer)) {
          throw new Error('Preview Render Error: Could not create layer bitmap data');
        }

        this.layerMap.set(layerId, layerRenderer);
      }

      var layerBitmap = this.layerMap.get(layerId); // Set the creative layer back on the bitmap layer so we can accurately do diffs to determine render state

      layerBitmap.creativeLayer = creativeLayer;
      return layerBitmap;
    }
  }]);
  return LayerRendererCache;
}();

exports["default"] = LayerRendererCache;